import { useContext } from 'react';
import { ClusterModalContext } from './clusterModalProvider';

export function useClusterModalContext() {
  const context = useContext(ClusterModalContext);
  if (!context) {
    throw new Error('useClusterModalContext must be used within a ClusterModalProvider');
  }
  return context;
}
